module.exports = __webpack_public_path__ + "static/img/2926_phase_function_Paper_PointsHejduk_Prediction.cb0344b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2926_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jCRJ
// module chunks = 0